import toast from 'react-hot-toast';
// import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import config from '../../../config';
import {
  setAuthToken,
  setRefreshToken,
  setDeviceIdentity,
  removeAuthToken,
  removeRefreshToken,
  removeDeviceIdentity,
} from '../../utils/auth';
import { getItem } from '../../utils/localStorageFn';
import { injectScript } from '../register/hook';

const registerPaywallFlow = () => {
  // const dispatch = useDispatch();
  const history = useHistory();

  const updatePaywallSettings = ({
    articleCount,
    autoEnableArticle,
    changeModalText,
    setShowModal,
  }) => {
    const publisherData = JSON.parse(getItem('publisherdata'));
    const publisherId = publisherData.id;
    const userData = JSON.parse(getItem('userdata'));
    const { accessToken } = userData;

    setShowModal(true);
    changeModalText('Setting your default preferences...');

    (async () => {
      try {
        const payload = {
          autoEnableArticle,
          countries: [],
          facebookAPIVersion: '',
          facebookLoginEnabled: false,
          isGeoFencingEnabled: false,
          numFreeArticles: articleCount,
        };

        const response = await fetch(
          `${config.ApiBaseUrl}/publisher/${publisherId}/updatePaywallSettings`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(payload),
          }
        );

        const json = await response.json();
        const { success } = json;

        if (success) {
          setAuthToken(userData.accessToken);
          setRefreshToken(userData.refreshToken);
          setDeviceIdentity(userData.deviceKey);

          setShowModal(false);
          await injectScript(history);
        }
      } catch (e) {
        setShowModal(false);
        toast.error(e.message);

        removeAuthToken();
        removeRefreshToken();
        removeDeviceIdentity();

        console.log(e);
      }
    })();
  };

  return updatePaywallSettings;
};

export default registerPaywallFlow;
